// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"463":"0fefa75d","704":"271d8031"}[chunkId] + ".chunk.css";
};